<div class="bottom-info-component shr-bottominfo-message-component sync-videos" fxLayout="column">
    <div class="sync-video" *ngFor="let vm of downloadingDeviceSessions | async" fxLayout="row"
        fxLayoutAlign="start center">
        <div class="state-text" [matTooltip]="vm.stateText">
            {{vm.stateText}}
        </div>
        <div class="state-icon">
            <mat-icon matTooltip="{{vm.isComplete == true ? 'Synchronized' : 'Partially Synchronized'}}"
                [style.color]="vm.isComplete == true ? 'blue' : 'white'">
                cloud_download</mat-icon>
        </div>
        <div class="progress">
            <mat-progress-bar *ngIf="vm.isDownloading == true && vm.isQueued == false" mode="determinate"
                [value]="vm.downloadProgress"></mat-progress-bar>
        </div>
        <div class="actions">
            <button
                *ngIf="vm.isProcessing === false && vm.isComplete == false && vm.isDownloading == true && vm.isPaused == true"
                matTooltip="Resume Synchronization" mat-icon-button (click)="resumeDownloadSession(vm)">
                <mat-icon>cloud_download</mat-icon>
            </button>
            <button
                *ngIf="isReadOnly == false && vm.isProcessing === false && vm.isDownloading == true && vm.isPaused == false"
                matTooltip="Cancel Synchronization" mat-icon-button (click)="cancelDownloadSession(vm)">
                <mat-icon>cancel</mat-icon>
            </button>
            <button
                *ngIf="isReadOnly == false && vm.isProcessing === false && vm.isDownloading == true && vm.isPaused == false"
                matTooltip="Pause Synchronization" mat-icon-button (click)="pauseDownloadSession(vm)">
                <mat-icon>pause</mat-icon>
            </button>
        </div>
    </div>
</div>
